import { useReadMemory } from "./useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useState } from "react";

export const useGetOrgIdentifier = () => {
    const user = useReadMemory(MemoryType.USER);
    const [organizationIdentifier] = useState(() => user?.organizationIdentifier);
    return organizationIdentifier;
};
